module.exports = __webpack_public_path__ + "static/media/html_css_js.7d55e7d8.png";